import { getResults } from "reducers";
import Immutable from "immutable";

export const getProfitLimits = (state) =>
  getResults(state).get("profitLimits", Immutable.Map());
